<template>
  <div>
    <!-- <div v-if="devmodel" class="devbox">
      <v-btn
        color="primary"
        :class="devboxShow ? 'extbtn' : 'extbtn-ani'"
        fab
        small
        @click="devboxShow = !devboxShow"
      >
        <v-icon v-if="devboxShow">feedback</v-icon>
        <v-icon v-else>info</v-icon>
      </v-btn>
      <v-alert v-if="devboxShow" type="info" dark elevation="2">欢迎访问MAKjust开发版官方网站，这是一个快速迭代的测试性站点。</v-alert>
      <v-alert
        v-if="devboxShow"
        type="info"
        dark
        elevation="2"
        style="margin-bottom:0"
      >非赞助者测试账号系统将会在每月初自动回收。</v-alert>
    </div> -->
    <!-- <transition name="fade-transition">
      <loading v-if="loading" />
    </transition> -->
      <loading v-if="loading" />
      <router-view v-else />
  </div>
</template>

<script>
import mjp from "./plugins/makjust";
import loading from "./core/components/loading.vue";

export default {
  provide() {
    return {
      reload: this.reload,
      reloadData: this.reloadData,
    };
  },
  data() {
    return {
      loading: true,
      devmodel: false,
      devboxShow: true,
      isAlive: true
    };
  },
  components: {
    loading
  },
  created() {
    //初始化各项公开OPTION -> VUEX
    mjp.init().then(options => {
      /**
       * 根据option_type进行设置项的格式化。
       * V1.2
       * Lonay@2021/05/19
       * 加入类型验证，并对错误类型进行正确报错。
       * 加入强制转换。
       */
      let typeErr;
      for (let option of options.data.results) {
        let _value;
        if (option.option_type == "_string" || option.option_type == "_url") {
          //=> String/Url
          _value = "" + option.option_value;
        } else if (option.option_type == "_array") {
          //=> Array
          try {
            _value = JSON.parse(option.option_value);
          } catch (e) {
            _value = 'undefined';
            typeErr += `    at options.${option.option_name}, ${e.messgae}\n`;
          }
        } else if (option.option_type == "_int" || option.option_type == "_num") {
          //=> Number                     ^兼容旧type
          if(isNaN(+option.option_value)){
            _value = 'undefined';
            typeErr += `    at options.${option.option_name}, Not a Number\n`;
          }else{
            _value = +option.option_value;
          }
        } else if (option.option_type == "_bool") {
          //=> Boolean
          switch (option.option_value) {
            case 1:
              _value = true
              break;
            case "1":
              _value = true
              break;
            case "true":
              _value = true
              break;
            case 0:
              _value = false
              break;
            case "0":
              _value = false
              break;
            case "false":
              _value = false
              break;
            default:
              _value = "undefined"
              typeErr += `    at options.${option.option_name}, Not a Boolean\n`;
              break;
          }
        } else {
          _value = "undefined";
          typeErr += `    at options.${option.option_name},typeof ${option.option_value}\n`;
        }
        this.$store.state.OPTIONS[option.option_name] = _value;
      }
      console.warn("Uncaught TypeError:Unable to convert an unknown types. \n" + typeErr)
      this.loading = false;
    });
    this.$store.commit("initUserInfo", window.localStorage);
  },
  mounted() {
    //虽然Vue官方不建议直接操作DOM，但是我还是要操作，嘻嘻。
    let loadpage = document.getElementById("iLoading");
    if (loadpage != null) {
      loadpage.style.opacity = 0;
      setTimeout(() => {
        document.body.removeChild(loadpage);
      }, 600);
    }

    if (
      location.toString().indexOf("localhost") > -1 ||
      location.toString().indexOf("dev.makjust.com") > -1
    )
      this.devmodel = true;
  },
  methods: {
    reload() {
      this.isAlive = false;
      this.$nextTick(() => {
        this.isAlive = true;
      });
    },
    reloadData(){
      mjp.getMe(this.$store.state.USER.sessionToken).then(r => {
        this.$store.dispatch("saveUserAsync", r.data);
      });
      this.isAlive = false;
      this.$nextTick(() => {
        this.isAlive = true;
      });
      setTimeout(() => {
        this.$store.commit("initUserInfo", window.localStorage);
        this.isAlive = false;
        this.$nextTick(() => {
          this.isAlive = true;
        });
      },100)
    }
  }
};
</script>

<style>
@media (min-width: 1904px) {
  .container {
    max-width: 1285px !important;
  }
}
.body {
}
h1,h2,h3,h4{
  font-weight: 100;
}
h5{
  font-weight: 500;
}
html::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
html::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  background: rgba(17, 202, 235, 0.6);
}
html::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  background: rgb(158, 158, 158);
}

.v-card__text::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.v-card__text::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  background: rgba(0, 0, 0, 0.6);
}
.v-card__text::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  background: rgba(0, 0, 0, 0);
}
.devbox {
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 2;
  margin-left: 30%;
  max-width: 310px;
  padding-bottom: -16px;
  opacity: 1;
  transition: all 0.463s ease;
  user-select: none;
}
.devbox .extbtn {
  position: absolute;
  z-index: 2;
  right: 0;
  bottom: 0;
  transform: translate(50%, 50%);
  background-color: #be2b2b !important;
}
.devbox .extbtn-ani {
  background-color: #be2b2b !important;
  animation: 1s linear 0s infinite alternate shakeshake;
}
.devbox > div {
  background-color: #0e64cf !important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.devbox .v-alert__icon {
  margin-right: 14px;
}
@keyframes shakeshake {
  0% {
    transform: translate(8px, 0) rotate(12deg);
  }
  50% {
    transform: translate(-8px, 0) rotate(-12deg);
  }
  100% {
    transform: translate(0, 0) rotate(0deg);
  }
}
</style>
